<script setup>
import { reactive, watch } from 'vue'

const props = defineProps(['newApt', 'appointments', 'totalCodeModel']);
const emits = defineEmits(['onCodeSelect']);

const state = reactive({
    billedForTheDay: null,
    billedTooManyTimes: null,
    reason: '',
    isValid: false,
    selected: false,
})
validate();
codeIsSelected();

watch(() => props.newApt, (val) => {
    validate();
}, { deep: true })


function toggleSelect() {
    state.selected = !state.selected
    codeIsSelected();
}

function codeIsSelected() {
    let codeModel;
    if (state.selected) {
        codeModel = {
            code: 'K013',
            price: 100,
            name: 'Counselling'
        }
        emits('onCodeSelect', [codeModel]);
    } else {
        codeModel = {
            code: [],
            price: 0,
            name: '',
        }
        emits('onCodeSelect', []);
    }
    // emits('onCodeSelect', [codeModel]);
}

// function billedForTheDay() {
//     return props.appointments.filter(apt => apt.date == props.newApt.date).length > 0;
// }
function validate() {
    // can bill 3 times per year, and with no other code on the same day
    state.billedForTheDay = props.appointments.filter(apt => apt.date == props.newApt.date).length > 0;
    if (state.billedForTheDay) {
        state.reason = 'Patient already billed today.'
        state.isValid = false;
        state.selected = false;
        return
    }
    let numberOfTimesBilledLastYear = 0;
    props.appointments.forEach(apt => {
        apt.codes.forEach(code => {
            if (code == 'K013') numberOfTimesBilledLastYear++;
        })
    });
    if (numberOfTimesBilledLastYear >= 3) {
        state.billedTooManyTimes = true;
        state.reason = 'K013 billed 3 times within last year.'
        state.isValid = false;
        state.selected = false;
        return
    }
    const x = props.totalCodeModel;
    let numberOfAptsBilledToday = props.totalCodeModel.length;
    // if we have an apt lined up that is not k013 or we have multiple apts -> no k013
    if ((numberOfAptsBilledToday == 1 && props.totalCodeModel[0].code != 'K013') || numberOfAptsBilledToday > 1) {
        state.isValid = false;
        state.selected = false;
        state.reason = 'Cannot be billed alongside any other code.'
        return
    }

    state.isValid = true;
    state.selected = true;
    codeIsSelected();
}


</script>
<template>
    <div :class="{ applicable: state.isValid, selected:state.selected }" class="code-block" @click="toggleSelect">
        <div class="info">
            <div class="code">K013</div>
            <div class="name">Counselling</div>
            <div class="price">$100</div>
        </div>
        <div v-if="!state.isValid" class="reason">{{ state.reason }}</div>
    </div>
</template>
<style scoped lang="scss"></style>
